import _slicedToArray from "/home/runner/work/web/web/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import _asyncToGenerator from "/home/runner/work/web/web/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/home/runner/work/web/web/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import { FEATURE_ENABLE_WAITLIST, FEATURE_GIFTING, FEATURE_ONBOARDING_2_2, FEATURE_SKIP_POSTAL_VALIDATION, FEATURE_WEBSITE_REFRESH, FEATURE_PREVIEW_POPLAR, FEATURE_FOOTER_NEWSLETTER, FEATURE_3DS, FEATURE_REMOVAL_SIGN_UP_YOHANA_US } from '@store/constants/split';
import { shoeboxFactory } from '@yoweb/ui/contexts/shoeboxFactory';
import { isFeatureTreatments } from '@yoweb/utils/server/split/withFeature';
import { withStoreI18n } from '@store/lib/server/i18n';

var _shoeboxFactory = shoeboxFactory('externalConfig'),
    useExternalConfig = _shoeboxFactory.useShoebox,
    Provider = _shoeboxFactory.Provider,
    ExternalConfigShoebox = _shoeboxFactory.Element,
    createShoeboxStateWrapper = _shoeboxFactory.createShoeboxStateWrapper; // *Note*: the return value of this function is serialized to the client bundle on
// every single page sent to client within _app
//
// Do not return any values from this object that you would consider private
// or internal. This is for global state that is intended to be seen externally.
//
// Also, extend the return value as a last resort - when page props do not suffice for passing
// down a configuration value.


export { useExternalConfig, Provider, ExternalConfigShoebox, createShoeboxStateWrapper };
export var createStoreExternalConfigState = createShoeboxStateWrapper( /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(ctx) {
    var _featureResponse$prop;

    var _yield$Promise$all, _yield$Promise$all2, privateRuntimeConfig, withFeature, _yield$Promise$all3, _yield$Promise$all4, withStoreI18nResult, featureResponse, treatments;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return Promise.all([import('@store/lib/server/privateRuntimeConfig'), import('@store/lib/server/composables/withFeature')]);

          case 2:
            _yield$Promise$all = _context.sent;
            _yield$Promise$all2 = _slicedToArray(_yield$Promise$all, 2);
            privateRuntimeConfig = _yield$Promise$all2[0].privateRuntimeConfig;
            withFeature = _yield$Promise$all2[1].withFeature;
            _context.next = 8;
            return Promise.all([withStoreI18n(ctx, {
              ns: ['common']
            }), withFeature([{
              name: FEATURE_ENABLE_WAITLIST,
              anonymous: true
            }, {
              name: FEATURE_WEBSITE_REFRESH,
              anonymous: true
            }, {
              name: FEATURE_GIFTING,
              anonymous: true
            }, {
              name: FEATURE_ONBOARDING_2_2,
              anonymous: true
            }, {
              name: FEATURE_PREVIEW_POPLAR,
              anonymous: true
            }, {
              name: FEATURE_SKIP_POSTAL_VALIDATION,
              anonymous: true
            }, {
              name: FEATURE_FOOTER_NEWSLETTER,
              anonymous: true
            }, {
              name: FEATURE_REMOVAL_SIGN_UP_YOHANA_US,
              anonymous: true
            }, {
              name: FEATURE_3DS,
              anonymous: true
            }], {
              passThrough: true
            })(ctx)]);

          case 8:
            _yield$Promise$all3 = _context.sent;
            _yield$Promise$all4 = _slicedToArray(_yield$Promise$all3, 2);
            withStoreI18nResult = _yield$Promise$all4[0];
            featureResponse = _yield$Promise$all4[1];
            treatments = isFeatureTreatments(featureResponse) ? (_featureResponse$prop = featureResponse.props) === null || _featureResponse$prop === void 0 ? void 0 : _featureResponse$prop.treatments : {};
            return _context.abrupt("return", {
              baseUrl: privateRuntimeConfig.baseURL(),
              basePoplarURL: privateRuntimeConfig.basePoplarUrl(),
              baseUsUrl: privateRuntimeConfig.baseUsURL(),
              baseJpUrl: privateRuntimeConfig.baseJpURL(),
              basePoplarUsURL: privateRuntimeConfig.basePoplarUsURL(),
              basePoplarJpURL: privateRuntimeConfig.basePoplarJpURL(),
              appLinks: {
                android: privateRuntimeConfig.appLinks.android(),
                ios: privateRuntimeConfig.appLinks.ios()
              },
              datadog: {
                applicationId: privateRuntimeConfig.datadog.applicationId(),
                clientToken: privateRuntimeConfig.datadog.clientToken(),
                disabled: !!privateRuntimeConfig.datadog.disabled,
                site: privateRuntimeConfig.datadog.site()
              },
              mixpanel: {
                requireCookie: !!privateRuntimeConfig.mixpanel.requireCookie,
                token: privateRuntimeConfig.mixpanel.token(),
                proxyUrl: privateRuntimeConfig.mixpanel.proxyUrl(),
                domain: privateRuntimeConfig.mixpanel.domain
              },
              env: privateRuntimeConfig.env(),
              fallbackI18nextInitOptions: withStoreI18nResult.props.i18nextPageResponse.config,
              globalFeatures: {
                enableWaitlist: (treatments === null || treatments === void 0 ? void 0 : treatments[FEATURE_ENABLE_WAITLIST]) === 'on',
                enableWebsiteRefresh: (treatments === null || treatments === void 0 ? void 0 : treatments[FEATURE_WEBSITE_REFRESH]) === 'on',
                enableGifting: (treatments === null || treatments === void 0 ? void 0 : treatments[FEATURE_GIFTING]) === 'on',
                enableOnboarding2_2: (treatments === null || treatments === void 0 ? void 0 : treatments[FEATURE_ONBOARDING_2_2]) === 'on',
                enablePoplarPreview: (treatments === null || treatments === void 0 ? void 0 : treatments[FEATURE_PREVIEW_POPLAR]) === 'on',
                enableSkipPostalValidation: (treatments === null || treatments === void 0 ? void 0 : treatments[FEATURE_SKIP_POSTAL_VALIDATION]) === 'on',
                enableJpFooterNewsletter: (treatments === null || treatments === void 0 ? void 0 : treatments[FEATURE_FOOTER_NEWSLETTER]) === 'on',
                enableRemovalSignUpYohanaUs: (treatments === null || treatments === void 0 ? void 0 : treatments[FEATURE_REMOVAL_SIGN_UP_YOHANA_US]) === 'on',
                enable3ds: (treatments === null || treatments === void 0 ? void 0 : treatments[FEATURE_3DS]) === 'on'
              },
              places: {
                publicKey: privateRuntimeConfig.places.publicKey()
              },
              prismic: {
                repository: privateRuntimeConfig.prismic()
              },
              recaptcha: {
                publicKey: privateRuntimeConfig.recaptcha.publicKey()
              },
              stripe: {
                allowedPaymentCountry: privateRuntimeConfig.stripe.allowedPaymentCountry,
                publicKey: privateRuntimeConfig.stripe.publicKey()
              },
              facebook: {
                pixelId: privateRuntimeConfig.facebook.pixelId()
              },
              braze: {
                apiKey: privateRuntimeConfig.braze.apiKey,
                baseUrl: privateRuntimeConfig.braze.baseUrl
              }
            });

          case 14:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function (_x) {
    return _ref.apply(this, arguments);
  };
}());